import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutModule } from 'src/app/layout/layout.module';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedModule } from 'src/app/shared/shared.module';
// it_img:"" //item image
// it:"" //item name
// or_id:"" //invoice number
// dt:"" //date
// qt:"" //quantity 
// u_p:''//unit price
// tax:'' //tax
// amt:'' //amount
// inv:'' //invoice
@Component({
  selector: 'app-order-purchased',
  templateUrl: './order-purchased.component.html',
  standalone:true,
  styleUrls: ['./order-purchased.component.scss'],
  imports:[ LayoutModule,SharedModule]
})
export class OrderPurchasedComponent {
  
  public orderData;
  public userType!:string;
  public isOffferData:boolean=false
  constructor(private commonService:CommonService,private router:Router,private appService:AppService, private route:ActivatedRoute){}
  ngOnInit(): void {
    if(this.appService.getData('training-portal.userInfo')){
      // get the user type to know where to redirect to "My courses" or "Course Dashborad of Company"
      this.userType=JSON.parse(this.appService.getData('training-portal.userInfo'))["group_type"]
    }
    this.commonService.setTitle("")
    this.route.queryParams.subscribe((params:any)=>{
      if(params && params.data){
        this.orderData=JSON.parse(params.data)
        this.orderData.tax=this.orderData.tax.toFixed(2) 
        this.orderData.amt=this.orderData.amt.toFixed(2) 
        this.orderData.u_p=this.orderData.u_p.toFixed(2) 
        // if company buys offer is there then don't show the Go to course option hence isOfferData used.
        if(this.orderData.hasOwnProperty('type') && this.orderData.type=="offer_package"){
          this.isOffferData=true
        }
      }
      else{
        let userType=JSON.parse(this.appService.getData('training-portal.userInfo'))["group_type"]
        this.commonService.managerRedirect(userType)
      }
    })
  }
  goToMyCourse(){
    if(this.userType=="individual"){
      this.router.navigate(['/individual/my-course'])
    }
    else{
      this.router.navigate(['/course/dashboard'])
    }
  }
  onDownloadInvoice(){
    this.appService.downloadFile(this.orderData.inv,'invoice')
  }
  goToUserManagement(){
    this.router.navigate(['/dashboard/dashboard2'])
  }
}
